<template>
  <div
    id="convey-connect-sdk"
    class="convey-connect-sdk"
  ></div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex';

export default {
  name: "ConveyConnectSDK",
  computed: {
    ...mapGetters("agency", ["agencySettings", "isSDKEnabled"]),
    coreConnectEnabled() {
      if (!this.agencySettings) {
        return false;
      }
      return this.agencySettings['core:connectEnabled'];
    },
  },
  mounted() {
    if (this.$conveyInstance) {
      this.$nextTick(() => {
        this.$conveyInstance.conveyConnectCall({
          $container: "convey-connect-sdk",
        }).onReady(() => {
          console.log("[SDK:conveyConnectCall] onReady");
        }).onEvent((eventName, eventData) => {
          this.handleConveyConnectEvents({ eventName, eventData });
        }).onError((err) => {
          console.log("[SDK:conveyConnectCall] onError: ", err);
        });
      });
    }
  },
  methods: {
    handleConveyConnectEvents({ eventName, eventData }) {
      console.log(`[SDK:conveyConnectCall] ${eventName}: `, eventData);

      switch(eventName) {
        case 'chat:createConversation':
          break;
        case 'chat:updateConversation':
          break;
        case 'chat:closeConversation':
          break;
        case 'chat:assignConversationAgent':
          break;
        case 'chat:unassignConversationAgent':
          break;
        case 'chat:addRecipientToConversation':
          break;
        case 'chat:removeRecipientFromConversation':
          break;
        default:
      }
    }
  },
};
</script>

<style lang="scss">
#convey-connect-sdk {
  > div {
    width: 100% !important;

    button[data-type=CloseConveyConnect] {
      display: none !important;
    }

    .ConveyEmbed--FlexCenterRow {
      margin-bottom: 4px !important;
    }
  }
}
</style>